/**
 * AccessNotConfirmed.tsx -- the explicit access-denied state
 * (ADR-20260826-82qe). Rendered by `../CapabilityProvider` in place of
 * `children` on any of `decodeClaim`'s four denial cases (absent,
 * schema-invalid, role-missing, unrecognised-role): never a blank screen
 * indistinguishable from a broken page.
 *
 * Carries no capability or claim data at all -- it takes no props and
 * reads no context, so it cannot leak an internal identifier, stack frame
 * or claim field into what the customer sees even by accident. Renders no
 * adapter component (ADR-20260824-78jg as extended by ADR-20261005-dxxe):
 * there is no interactive control here for `Button`/`Checkbox`/
 * `FormControlLabel` to render, only plain semantic HTML -- the "no
 * wrapper beyond Button, Checkbox and FormControlLabel" limit this task
 * group's standards hold is satisfied trivially rather than approached.
 */
import { accessNotConfirmedContent as content } from "./content";

export function AccessNotConfirmed() {
  return (
    <div>
      <h1>{content.heading}</h1>
      <p>{content.message}</p>
    </div>
  );
}
